import React from 'react'
import { connect } from 'react-redux'
import Authorizing from './Authorizing'
import { Redirect } from 'react-router'

const mapStateToProps = (state, props) => {
  return {
    authToken: state.token,
  }
}

const AuthorizeContainer = props => {
  if (props.authToken)
    return <Redirect to="/select-repository" />

  return <Authorizing />
}

export default connect(mapStateToProps)(AuthorizeContainer)



// WEBPACK FOOTER //
// ./src/pages/Authorizing/Container.js